export const FETCH_UPDATE_ROLES_REQUEST = 'FETCH_UPDATE_ROLES_REQUEST'
export const FETCH_UPDATE_ROLES_SUCCESS = 'FETCH_UPDATE_ROLES_SUCCESS'
export const FETCH_UPDATE_ROLES_FALUIRE = 'FETCH_UPDATE_ROLES_FALUIRE'
